import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

function ShowWhenContainsOtherThanH5(props) {
  const { children } = props;

  if (
    _.isArray(children) &&
    children.filter(x => x && x.type !== 'h5').length >= 1
  ) {
    return <>{children}</>;
  }
  if (!_.isArray(children) && children.type !== 'h5') {
    return <>{children}</>;
  }

  return <></>;
}

ShowWhenContainsOtherThanH5.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
};

export default ShowWhenContainsOtherThanH5;
